import {
  Autocomplete,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useLocation } from "react-router-dom";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  orderStatus,
  type,
  bays,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const isPriority =
    searchParams.has("status") && searchParams.get("status") === "priority";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          SSS Job No
        </InputLabel>
        <TextField
          variant="outlined"
          name="sssJobNo"
          value={filterData.sssJobNo}
          onChange={handleChangeFilter("sssJobNo")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Cust Order
        </InputLabel>
        <TextField
          variant="outlined"
          name="custOrder"
          value={filterData.custOrder}
          onChange={handleChangeFilter("custOrder")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Customer
        </InputLabel>
        <TextField
          variant="outlined"
          name="customer"
          value={filterData.customer}
          onChange={handleChangeFilter("customer")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      {/* <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Customer
        </InputLabel>
        <Autocomplete
          disablePortal
          options={customers}
          value={filterData.customer}
          onChange={(_, newValue) => handleChangeFilter("customer")(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid> */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Order Date Start
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.orderDateStart}
            onChange={(newValue) =>
              handleChangeFilter("orderDateStart")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Order Date End
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.orderDateEnd}
            onChange={(newValue) =>
              handleChangeFilter("orderDateEnd")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Freight Line Order
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.freightLineOrder}
            onChange={(e) => handleChangeFilter("freightLineOrder")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Picker
        </InputLabel>
        <Autocomplete
          disablePortal
          options={pickers}
          getOptionLabel={(option) => option.name}
          value={filterData.picker}
          onChange={(_, newValue) => handleChangeFilter("picker")(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid> */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Bay
        </InputLabel>
        <Autocomplete
          disablePortal
          options={bays}
          getOptionLabel={(option) => option.bay_name}
          value={
            filterData.bay
              ? bays.find((b) => b.bay_code === filterData.bay)
              : null
          }
          onChange={(_, newValue) => {
            // Store bay_code in state
            handleChangeFilter("bay")(null, newValue ? newValue.bay_code : "");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid>
      {type !== "delay-picking" && !isPriority ? (
        <Grid item xs={12} md={4}>
          <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Status
          </InputLabel>
          <FormControl fullWidth>
            <Select
              value={filterData.status}
              onChange={(e) => handleChangeFilter("status")(e)}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            >
              <MenuItem value="">Select Status</MenuItem>
              {orderStatus?.map((status) => (
                <MenuItem key={status.code} value={status.code}>
                  {status.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      ) : null}

      {/* <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Cutoff Start
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={filterData.cutoffStart}
            onChange={handleChangeFilter("cutoffStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Cutoff End
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={filterData.cutoffEnd}
            onChange={handleChangeFilter("cutoffEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid> */}
      {/* <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Order Line Min
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.orderLineMin}
          onChange={handleChangeFilter("orderLineMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Order Line Max
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.orderLineMax}
          onChange={handleChangeFilter("orderLineMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid> */}
      {/* <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Pick Up Qty Min
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.pickUpQtyMin}
          onChange={handleChangeFilter("pickUpQtyMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Pick Up Qty Max
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.pickUpQtyMax}
          onChange={handleChangeFilter("pickUpQtyMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid> */}

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Git
        </InputLabel>
        <TextField
          variant="outlined"
          name="git"
          value={filterData.git}
          onChange={handleChangeFilter("git")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default FilterItems;
